'use strict';

// Import Libraries
import React from 'react';
import PropTypes from 'prop-types';
// Import JSX Modules
import PricesTable from './prices-table';

// -----------------------------------------------------------
//  ProductDescription
// -----------------------------------------------------------
const ProductDescription = ({ currentProduct, products, deliveryOptions, aiContent }, { showPricesTable, description }) => {
  description = (currentProduct && currentProduct.description) || description;

  if (showPricesTable) {
    return (
      <div className="product-description">
        <div className="row">
          <div className="col-lg-9 col-12" dangerouslySetInnerHTML={{ __html: description }} />
          {aiContent && (
            <div className="col-lg-9 col-12 mt-3">
              <div className="ai-generated-description" dangerouslySetInnerHTML={{ __html: aiContent }} />
            </div>
          )}
          <div className="col-lg-9 col-12">
            <PricesTable products={products} delivery_options={deliveryOptions} />
          </div>
        </div>
      </div>
    );
  }

  if (description || aiContent) {
    return (
      <div className="row">
        <div className="col-12 col-sm-12 col-lg-9">
          {description && (
            <div className="product-description" dangerouslySetInnerHTML={{ __html: description }} />
          )}
          {aiContent && (
            <div className="ai-generated-description mt-3" dangerouslySetInnerHTML={{ __html: aiContent }} />
          )}
          <hr></hr>
        </div>
      </div >
    );
  }

  return null;
};

ProductDescription.contextTypes = {
  description: PropTypes.string,
  showPricesTable: PropTypes.bool
}

export default ProductDescription;
